import Locale from '@/model/Locale';
import i18n from '@/plugins/i18n';
import localized from '@/plugins/vue-localized-formatter/src/localized';
import { preferredGuestCurrency } from '@/services/billing-utils';
import store from '@/store/store';
import { computed, ref } from 'vue';

export function useSeatingTimeItems() {
  return ref([...new Array(24)].map((e, i) => ({
    value: (i + 1) * 15,
    text: (localized.durationFromSeconds((i + 1) * 15 * 60)),
  })));
}

export function useTimeInAdvanceItems() {
  return ref([
    ...[1, 5, 10, 15, 20, 30, 45, 60, 90], // 1-90min
    ...[...new Array(23)].map((e, i) => ((i + 1) * 60)), // 2-23 hours
    ...[...new Array(730)].map((e, i) => ((i + 1) * 60 * 24)), // 1-365 days
  ].map((e, i) => ({ value: e, text: localized.durationFromSeconds(e * 60) })));
}

export function partysizes() {
  return [...new Array(500)].map((e, i) => i + 1);
}

export function useBookingCaps() {
  return [0, 15, 30, 45, 60, 90, 120].map((t) => ({
    value: t,
    text: (localized.durationFromSeconds(t * 60)),
  }));
}

export function useOnlineTabs() {
  return computed(() => store.state.settings.tabs.filter((s) => s.usingWeekdaysAndTimes));
}

export function useAccountLocale() {
  return computed(() => store.state.settings.account.locale);
}

export function useLanguages() {
  return computed<Locale[]>(() => store.state.codes.locales);
}
export function useSortedLanguages() {
  return computed<Locale[]>(() => store.state.codes.locales.sort(
    (a: Locale, b: Locale) => a.language.localeCompare(b.language),
  ));
}

export function emptySeatItems() {
  return [...new Array(11)].map((e, i) => (i));
}

export function useDaysInAdvanceItems() {
  return [...new Array(730)].map((e, i) => ({
    value: i + 1, text: i18n.tc('label.x_days', (i + 1)),
  }));
}

export const usePreferredGuestCurrency = () => computed(
  () => preferredGuestCurrency(store.state.settings.account.countryCode),
);
